import i18next from 'i18next'
import * as React from 'react'
import { FormControls } from '../../../../utils/forms'

type CollectionEditorLayoutProps = {
  nameValue: string
  descriptionValue: string
  onNameChange: (name: string) => void
  onDescriptionChange: (description: string) => void
}

export const CollectionEditorLayout = (props: CollectionEditorLayoutProps) => (
  <>
    {/* Name */}
    <FormControls.FormItemInGroup
      type="text"
      controlId="create-coll-name"
      label={i18next.t('auth:name')}
      placeholder={i18next.t('collection:editCollectionNamePlaceholder')}
      required={true}
      value={props.nameValue}
      onChange={props.onNameChange}
      maxLength={120}
    />

    {/* Notes (opt.) */}
    <FormControls.FormItemInGroup
      as="textarea"
      controlId="create-coll-notes"
      label={i18next.t('collection:editCollectionDescription')}
      rows={4}
      required={false}
      value={props.descriptionValue}
      onChange={props.onDescriptionChange}
    />
  </>
)
